import React ,{useCallback,useState,useEffect} from "react";
import WithSidebar from "../../templates/withSidebar";
import {
    ArrowLeftOutlined
} from "@ant-design/icons"
import {
    Breadcrumb,
    Row,
    Col,
    Space,
    Button,
    Form,
    theme,
    Divider,
    Table,


} from "antd"
import {DATA_MASTER_DATA_TYPE,WORK_PERIOD,SUCCESS_CODE} from "../../lib/const"
import useLineOfWork from "../../lib/hooks/useLineOfWork";

import useMasterData from "../../lib/hooks/useMasterData";
import { useNavigate , useLocation ,} from "react-router-dom";

import Heading from "../../components/common/heading";
import {routes} from "../../routes";

import {getDetailVocReport} from "../../services/vocReportService"
import "./style.css";
const { useToken } = theme;



export const ViewVocReport = () => {
    
    const location = useLocation(); // ดึง location ปัจจุบัน
    const queryParams = new URLSearchParams(location.search); // ใช้ URLSearchParams เพื่อดึงค่าจาก URL
  
    // ดึงค่าต่าง ๆ จาก URL
    const customerGroupByAge = queryParams.get('customerGroupByAge');
    const lineOfWorkId = queryParams.get('lineOfWorkId') || ''; // ถ้าไม่มีค่าให้ใช้ค่าว่าง
    const yearOfBudget = queryParams.get('yearOfBudget');
    const quarter = queryParams.get('quarter');
  
    // สร้าง searchValue object
    const searchValue = {
      customerGroupByAge: customerGroupByAge,
      lineOfWorkId: lineOfWorkId,
      yearOfBudget: yearOfBudget,
      quarter: quarter
    };
    const [data , setData] = useState();
    const [workPeriod] = useMasterData(DATA_MASTER_DATA_TYPE, WORK_PERIOD);
    const [lineOfWork] = useLineOfWork();
    // getDetailVocReport(searchValue)
    const [form] = Form.useForm();
    // const form = useRef(null);
    const {token} = useToken();

      
      
    const fetchDetail = useCallback(
        async (searchValue) => {
            const res = await getDetailVocReport(searchValue);
            if (res.data.code === SUCCESS_CODE) {
                const { objectValue } = res.data;
                setData(objectValue[0]);

            }
            
        },
        
        [setData,customerGroupByAge, lineOfWorkId, yearOfBudget, quarter]
    );
    useEffect(() => {
    fetchDetail(searchValue);
    }, [ fetchDetail]);

    
    //Test column
    const columns = [
        {
            title: "หัวข้อ",
            dataIndex: "topic",
            key: "topic",
        },
        {
            title: "หมวดหมู่",
            dataIndex: "category",
            key: "category",
        },
        {
            title: "รายละเอียด",
            dataIndex: "details",
            key: "details",
            render: (details) => details.map((item, index) => <div key={index}>{item}</div>),
        },
    ];

    const dataSource = [
        {
            key: "1",
            topic: "productAndService",
            category: "Want",
            details: data?.productAndServiceWantList || ["-"],
            customerGroupByAge:data?.customerGroupByAge || ["-"],
            lineOfWorkId:data?.lineOfWorkId || ["-"],
        },
        {
            key: "2",
            topic: "productAndService",
            category: "Expected",
            details: data?.productAndServiceExpectedList || ["-"],
        },
        {
            key: "3",
            topic: "support",
            category: "Want",
            details: data?.supportWantList || ["-"],
        },
        {
            key: "4",
            topic: "support",
            category: "Expected",
            details: data?.supportExpectedList || ["-"],
        },
        {
            key: "5",
            topic: "transaction",
            category: "Want",
            details: data?.transactionWantList || ["-"],
        },
        {
            key: "6",
            topic: "transaction",
            category: "Expected",
            details: data?.transactionExpectedList || ["-"],
        },
        {
            key: "7",
            topic: "crm",
            category: "Want",
            details: data?.crmList || ["-"],
        },
    ];

const getTopicInThai = (topic) => {
    switch (topic) {
        case "productAndService":
            return "ผลิตภัณฑ์และบริการ";
        case "support":
            return "การสนับสนุน";
        case "transaction":
            return "การทำธุรกรรม";
        case "crm":
            return "การจัดการลูกค้า";
        default:
            return topic;
    }
};

const getGroupbyAge = (customerGroupByAge) =>{
    switch (customerGroupByAge) {
        case 'f21fe673-10a2-11ee-9f58-b6e1cd76768a':
            return "กลุ่มลูกค้าไม่เกิน 3 ปี";
        case 'f2290fc6-10a2-11ee-9f58-b6e1cd76768a':
            return 'กลุ่มลูกค้า 3-10 ปี';
        case 'f2323054-10a2-11ee-9f58-b6e1cd76768a':
            return 'กลุ่มลูกค้ามากกว่า 10 ปี' ;
        case '8548650e-340e-11ee-b359-005056014b8c':
            return 'ไม่สามารถระบุข้อมูลได้' ;
    }
};

const getCategoryInThai = (category) => {
    switch (category) {
        case "Want":
            return "ต้องการ";
        case "Expected":
            return "คาดหวัง";
        default:
            return category;
    }
};
    return (
        
        <WithSidebar>
            <Row gutter={[24, 24]} style={{ marginTop: 15 }}>
                <Col span={24}>
                    <div className="flex items-center">
                        <Space size={12}>
                            <Button
                            type="link"

                            style={{ padding: 0 }}
                            >
                            <ArrowLeftOutlined style={{ color: "#000", fontSize: 16 }} />
                            </Button>
                            <Heading text={"รายละเอียด"} size={4} style={{ margin: 0 }} />
                        </Space>
                    </div>
                    <Breadcrumb
                    style={{ paddingTop: 10 }}
                    items={[
                        {
                        title: "รายงานจัดอันดับ ",
                        },
                        {
                        title: <span className="pr_green">รายละเอียด</span>,
                        },
                    ]}
                    />
                </Col>
                <Col span={24}>
                
                    <Form
                        ref={form}
                        form={form}
                        layout="vertical"
                        style={{ width: "100%", padding: "0 30px" }}
                        >
                        <Row gutter={[24, 16]} style={{ marginBottom: 10 }}>
                            <Col span={24} align="right">
                                <Space>
                                    <Button
                                        type="primary"
                                        // onClick={() =>
                                        // generatePDF()
                                        // }
                                    >
                                        PDF
                                    </Button>
                                </Space>
                            </Col>
                        </Row>
                        <div id="form-container">                  
                            <Row
                            gutter={[16, 24]}
                            className="card"
                            style={{ marginBottom: 30 }}
                            >
                                
                                {/* <Col span={24}>
                                    <Heading
                                        text={"รายละเอียดรายงาน"}
                                        size={4}
                                        style={{ margin: 0, color: token.thPrimary }}
                                    />
                                    <Divider />
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="ปีงบประมาณ" className="view-label">
                                    {data?.yearOfBudget || "-"}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="ไตรมาส" className="view-label">
                                    {data?.quarter || "-"}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="กลุ่มอายุลูกค้า" className="view-label">
                                    {data?.customerGroupByAge
                                        ? workPeriod.map((item) =>
                                            item.dataId === data?.customerGroupByAge
                                                ? item.dataDetailTh
                                                : ""
                                            )
                                    : "-"}
                                    </Form.Item>
                                </Col>  
                                <Col span={12}>
                                    <Form.Item label="สายปฏิบัติการ" className="view-label">
                                    {lineOfWork.map((e) =>
                                        e?.lineOfWork === data?.lineOfWorkId ? e.nameTh : ""
                                    )}
                                    </Form.Item>
                                </Col> */}
                                {/* <Col span={12}>
                                    <Form.Item label="ด้านผลิตภัณฑ์และบริการ(ต้องการ)" className="view-label">
                                    {data?.productAndServiceWantList?.map((item, index) => (
                                        <div key={index}>{item}</div>
                                    )) || "-"}
                                    </Form.Item>
                                </Col>  
                                <Col span={12}>
                                    <Form.Item label="ด้านผลิตภัณฑ์และบริการ(ความคาดหวัง)" className="view-label">
                                    {data?.productAndServiceExpectedList?.map((item, index) => (
                                        <div key={index}>{item}</div>
                                    )) || "-"}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="ด้านการสนับสนุนลูกค้า(ต้องการ)" className="view-label">
                                    {data?.supportWantList?.map((item, index) => (
                                        <div key={index}>{item}</div> 
                                    )) || "-"} 
                                    </Form.Item>
                                </Col>  
                                <Col span={12}>
                                    <Form.Item label="ด้านการสนับสนุนลูกค้า(ความคาดหวัง)" className="view-label">
                                    {data?.supportExpectedList?.map((item, index) => (
                                        <div key={index}>{item}</div> 
                                    )) || "-"}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="ด้านการทำธุรกรรม(ต้องการ)" className="view-label">
                                    {data?.transactionWantList?.map((item, index) => (
                                        <div key={index}>{item}</div> 
                                    )) || "-"} 
                                    </Form.Item>
                                </Col>  
                                <Col span={12}>
                                    <Form.Item label="ด้านการทำธุรกรรม(ความคาดหวัง)" className="view-label">
                                    {data?.transactionExpectedList?.map((item, index) => (
                                        <div key={index}>{item}</div> 
                                    )) || "-"} 
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Form.Item label="ด้านการจัดการสัมพันธุ์" className="view-label">
                                    {data?.crmList?.map((item, index) => (
                                        <div key={index}>{item}</div>
                                    )) || "-"}
                                    </Form.Item>
                                </Col> */}

                            <div>
                                <div className="main-title">
                                กลุ่มลูกค้าปัจจุบัน {data?.customerGroupByAge
                                        ? workPeriod.map((item) =>
                                            item.dataId === data?.customerGroupByAge
                                                ? item.dataDetailTh
                                                : ""
                                            )
                                    : "-"} (จัดลำดับ) (ณ สิ้น {data?.quarter || "-"} ปีงบประมาณ {data?.yearOfBudget || "-"})
                                </div>

                                <table class="detail-table">
                                <tr>
                                    <th rowspan="2" style={{ width: "15%" }}>กลุ่มลูกค้าปัจจุบัน</th>
                                    <th colspan="3">เสียงของลูกค้า</th>
                                    <th rowspan="2" style={{ width: "20%" }}>หน่วยงานที่ต้องนำ VOC ไปใช้</th>
                                    <th rowspan="2" style={{ width: "25%" }}>วัตถุประสงค์ของการใช้ VOC</th>
                                </tr>
                                <tr>
                                    <th style={{ width: "10%" }}>หัวข้อ</th>
                                    <th style={{ width: "10%" }}>ต้องการ/คาดหวัง</th>
                                    <th style={{ width: "40%" }}>รายละเอียด</th>
                                </tr>
                                <tbody>
                                    {/* ลูปผ่านข้อมูลใน dataSource */}
                                    {dataSource.map((item, index) => (
                                        <tr key={index}>
                                            {/* <td>
                                                {index === 0 ? (
                                                    data?.customerGroupByAge
                                                        ? workPeriod.map((item) =>
                                                                item.dataId === data?.customerGroupByAge
                                                                    ? getGroupbyAge(item.dataId)
                                                                    : ""
                                                            )
                                                        : "-"
                                                ) : (
                                                    ""
                                                )}</td> */}
                                            <td>
                                                {item.customerGroupByAge
                                                    ?.filter((value, index, self) => 
                                                    self.findIndex(v => v === value) === index // กรองข้อมูลซ้ำ
                                                    )
                                                    .map((customerGroupByAge, index) => (
                                                    <div key={index}>{getGroupbyAge(customerGroupByAge)}</div>
                                                    ))
                                                }
                                                </td>
                                            <td>{getTopicInThai(item.topic) || "-"}</td>
                                            <td>{getCategoryInThai(item.category) || "-"}</td>
                                            <td style={{ textAlign: "left" }}>
                                                {item.details?.map((detail, index) => (
                                                    <div key={index}>{detail}</div>
                                                ))}
                                            </td>
                                            {/* <td>{index === 0 ? (
                                                    data?.customerGroupByAge
                                                        ? lineOfWork.map((item) =>
                                                                item.lineOfWork === data?.lineOfWorkId
                                                                    ? item.nameTh
                                                                    : ""
                                                            )
                                                        : "-"
                                                ) : (
                                                    ""
                                                )}
                                            </td> */}
                                            <td>
                                                {item.lineOfWorkId
                                                    ?.filter((value, index, self) => 
                                                    self.findIndex(v => v === value) === index // กรองข้อมูลซ้ำ
                                                    )
                                                    .map((lineOfWorkId, index) => (
                                                    <div key={index}>{lineOfWorkId? lineOfWork.map((item)=>
                                                                        item.lineOfWork === lineOfWorkId?
                                                                    item.nameTh:""):""}</div>
                                                    ))
                                                }
                                                </td>
                                            <td></td>
                                        </tr>
                                    ))}
                                </tbody>
                                </table>
                                </div>
                            </Row>
                        </div>  
                    </Form>
                </Col>
            </Row>
        </WithSidebar>
    );
};